import { BASE_CLASS_PREFIX } from "../base/constants";
const cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}-image`
};
const numbers = {
  DEFAULT_Z_INDEX: 1070
};
export { cssClasses, numbers };